import { Component, Optional } from '@angular/core';
import { AuthService, LoginCredential } from '../auth.service';
import { FormsModule, NgForm } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'login',
  standalone: true,
  imports: [RouterLink, FormsModule, MatDialogModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  toggle: boolean = false;

  email: string = '';
  password: string = '';

  constructor(private authService: AuthService, @Optional() private dialogRef: MatDialogRef<LoginComponent>, private router: Router) {

  }

  cancel() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate(['/']);
    }

  }

  openMemberLogin() {
    if (!this.dialogRef) {
      this.router.navigate(['/member-login']);

    } else {
      this.dialogRef.close(null);
      setTimeout(() => {
        this.authService.openMemberLogin();
      }, 1000);
    }

  }

  toggleView() {
    if (this.toggle) {
      this.toggle = false;
    } else {
      this.toggle = true;
    }
  }

  async login(form: NgForm) {
    if (form.invalid) {
      this.authService.openSnackBar('Checkyour inputs', '');
      return;
    }

    let credential: LoginCredential = {
      email: form.value.email,
      password: form.value.password
    }

    try {
      const authResponse = await this.authService.login(credential);

      if (authResponse && authResponse.authenticated) {

        //this.authService.storeAuthToken(authResponse);
        this.authService.updateAuthState(authResponse);
        this.password = '';
        this.email = '';
        this.authService.openSnackBar('Login succesful', '');
        if (this.dialogRef) {
          this.dialogRef.close(authResponse);
        } else {
          this.router.navigate(['/']);
        }

        form.reset();

        return;
      }

      this.authService.openSnackBar('There was an error login in', 'please try again');

    } catch (err) {
      this.authService.openSnackBar('There was an error login in', 'please try again');
    }
  }

}
